import { useSelector } from "react-redux";
import { useLocation } from "react-router-dom";

import { Link } from "common/types/routing";

import { getLastSession } from "seneca-common/features/session/selectors/session";

import { linkThroughQuitSessionModal } from "features/classroom/features/sidebar/features/common/utils/linkThroughQuitSessionModal";
import { useWarnOnNavigateAwayFromSession } from "features/classroom/hooks/useWarnOnNavigateAwayFromSession";

type Props = {
  courseId: string;
  link: Link;
};

export default function useWordRowQuitSessionLink({
  courseId,
  link
}: Props): Link {
  const location = useLocation();

  const warnBeforeNavigation = useWarnOnNavigateAwayFromSession();

  const sessionType = useSelector(getLastSession)?.sessionType!;

  return linkThroughQuitSessionModal({
    warnBeforeNavigation,
    courseId,
    sessionType,
    link,
    currentLocation: location
  });
}
